import { useEffect } from 'react'

import { socketClient } from './socketClient'

export const useRealtimeConnection = () => {

    useEffect(() => {

        // =====================================================
        // 🚀 CONNECT
        // =====================================================

        if (!socketClient.active) {

            socketClient.activate()

            console.log('🚀 WebSocket conectado')
        }

        // =====================================================
        // ✅ CONNECTED
        // =====================================================

        socketClient.onConnect = () => {

            console.log('✅ STOMP conectado')
        }

        // =====================================================
        // ❌ WS ERROR
        // =====================================================

        socketClient.onWebSocketError = (error) => {

            console.error('❌ WebSocket error:', error)
        }

        // =====================================================
        // ❌ STOMP ERROR
        // =====================================================

        socketClient.onStompError = (frame) => {

            console.error('❌ STOMP error:', frame.headers['message'])
        }

    }, [])
}